import React, { useCallback, useImperativeHandle, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Modal as AntModal } from "antd";
import LocalCard from "../card";
import Success from "./success";
import Dialog from "./dialog";
import Text from "../text";

const Card = ({
  title,
  styles,
  closeable,
  close = () => {},
  fixedHeader = true,
  ...props
}) => {
  return (
    <LocalCard
      title={title}
      fixedHeader={fixedHeader}
      styles={{
        ...styles,
        body: {
          overflowY: "auto",
          overflowX: "hidden",
          paddingTop: ".5rem",
          padding: !fixedHeader ? "2.5rem 2.5rem 3rem" : "0rem 2.5rem 1rem",
          maxHeight: "calc(100vh - 7rem - 2rem - 4rem)", //here (screen height - header height - footer height - 2 * top)
          ...(styles?.body ?? {}),
        },
      }}
      extra={
        closeable && (
          <Text
            level={4}
            onClick={close}
            color="secondary"
            className="cursor-pointer m-15-l"
            children={<CloseOutlined size={50} />}
          />
        )
      }
      {...props}
    />
  );
};

const Modal = React.forwardRef(
  (
    {
      title = "",
      child = () => null,
      cardStyles = {},
      classNames = {},
      style,
      cardId = "",
      closeable = true,
      children,
      body = {},
      onClose = () => {},
      ...props
    },
    ref
  ) => {
    const [visible, setVisible] = useState(false);
    const [config, setConfig] = useState();
    const [data, setData] = useState({});

    useImperativeHandle(
      ref,
      () => ({
        data,
        close,
        open: (data, config) => {
          if (!!data) setData(data);
          if (!!config) setConfig(config);
          setVisible(true);
        },
      }),
      [data]
    );

    const close = useCallback(() => {
      setVisible(false);
      onClose(data);
    }, [data]);

    return (
      <AntModal
        open={visible}
        destroyOnClose={true}
        onCancel={() => closeable && close()}
        style={{
          top: "2rem",
          paddingBottom: 0,
          pointerEvents: "auto",
          ...style,
        }}
        modalRender={() => (
          <Card
            id={cardId}
            close={close}
            styles={cardStyles}
            closeable={closeable}
            classNames={classNames}
            children={children || child(data)}
            title={
              (typeof title === "function" ? title(data) : title) ||
              config?.title
            }
            {...body}
          />
        )}
        {...props}
      />
    );
  }
);

Modal.Card = Card;
Modal.Success = Success;
Modal.Dialog = Dialog;

export default Modal;
